import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers([
  'container',
  'data',
  'actions',
  'footer',
]);

const baseStyle = definePartsStyle({
  container: {
    paddingTop: '16',
    display: 'grid',
    gridTemplateAreas: '"lspace data actions rspace" "space space space space" "footer footer footer footer"',
    gridTemplateColumns: '1.5rem 1fr max-content 1.5rem',
    gridTemplateRows: 'min-content 1rem min-content',
  },
  data: {
    gridArea: 'data',
  },
  actions: {
    gridArea: 'actions',
    alignSelf: 'center',
    marginLeft: '12',
    display: 'flex',
    flexDirection: 'row',
    gap: '8',
  },
  footer: {
    gridArea: 'footer',
    borderTop: '1px solid',
    borderColor: 'border/minimal',
    paddingX: '24',
    paddingBottom: '8',
    paddingTop: '6',
  },
});

const SettingsCardTheme = defineMultiStyleConfig({
  baseStyle,
});

export default SettingsCardTheme;
